import * as P from "@components/customizing/print/Print.styles";

export const PrintDesignService = () => {
  return (
    <P.DesignBanner>
      <div className="content container-lg">
        <div className="textContent">
          <span>로고가 없다면?</span>
          <h6>칼렛스토어 디자인 서비스를 이용해보세요</h6>
          <span>
            간단한 로고 배치부터 브랜드 디자인까지! <br /> 가격별로 나에게 맞는
            디자인 서비스를 이용해보세요
          </span>
          <img
            src={
              "https://file.caretbio.com/caretbio/9ac7d2c8185a56a72ecf459b2021022a.png"
            }
            className="m_banner"
          />
          <a className="" href="/customizing/design-service/">
            서비스 보러가기
          </a>
        </div>
        <img
          src={
            "https://file.caretbio.com/caretbio/47ffdb3584f54f4251b1c79b3aad90c1.png"
          }
          className="pc_banner"
        />
      </div>
    </P.DesignBanner>
  );
};
